import axios from './axios';

function create(data) {
    return axios().post(`/warehouses`, data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function findByID(id) {
    return axios().get(`/warehouses/${id}`);
}

function remove(data) {
    return axios().delete(`/warehouses/${data.id}`);
}

function update(data) {
    return axios().put(`/warehouses/${data.id}`, data);
}

function list(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;

    return axios().get("/warehouses", {
        params
    })
}

function search(query) {
    return axios().get("/warehouses-search", { params: {
        search: query
    } })
}

export default {
    create,
    findByID,
    remove,
    update,
    list,
    search
}